import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Navbardesign from "../Components/Navbar";
import Footer from "../Components/FooterDomain/Footerdata";
import ContactBar from "../Components/Fixedpossion/Fixedposion";

const NotFoundPage = () => {
  useEffect(() => {
    document.title = "Mitha homes";

    const setMeta = (name, content) => {
      // Look for meta tags by name or property
      const elements = document.querySelectorAll(`meta[name="${name}"], meta[property="${name}"]`);
      if (elements.length > 0) {
        elements.forEach(el => el.setAttribute("content", content));
      } else {
        // Create if it doesn't exist
        const meta = document.createElement('meta');
        if (name.startsWith('og:') || name.startsWith('twitter:')) {
          meta.setAttribute('property', name);
        } else {
          meta.name = name;
        }
        meta.content = content;
        document.getElementsByTagName('head')[0].appendChild(meta);
      }
    };

    // Forcefully update everything
    setMeta("title", "Mitha homes");
    setMeta("description", "Mitha homes");
    setMeta("keywords", "Mitha homes");
    setMeta("og:title", "Mitha homes");
    setMeta("og:description", "Mitha homes");
    setMeta("twitter:title", "Mitha homes");
    setMeta("twitter:description", "Mitha homes");
  }, []);

  return (
    <>
      <Helmet>
        <title>Mitha homes</title>
        <meta name="title" content="Mitha homes" />
        <meta name="description" content="Mitha homes" />
        <meta name="keywords" content="Mitha homes" />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Mitha homes" />
        <meta property="og:description" content="Mitha homes" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content="Mitha homes" />
        <meta property="twitter:description" content="Mitha homes" />
      </Helmet>
      <Navbardesign />
      <div style={{ height: window.innerWidth <= 768 ? "60px" : "90px" }} />

      <div style={styles.container}>
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          style={styles.content}
        >
          <motion.h1
            style={styles.errorCode}
            initial={{ y: -50 }}
            animate={{ y: 0 }}
            transition={{ type: "spring", stiffness: 100 }}
          >
            404
          </motion.h1>
          <motion.h2
            style={styles.heading}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            Oops! Page Not Found
          </motion.h2>
          <motion.p
            style={styles.text}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.5 }}
          >
            The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.5 }}
          >
            <Link to="/" style={styles.button}>
              Back to Home
            </Link>

          </motion.div>
        </motion.div>
      </div>

      <Footer />
      <ContactBar />
    </>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh',
    padding: '60px 20px',
  },
  content: {
    textAlign: 'center',
    backgroundColor: '#ffffff',
    padding: '60px 40px',
    borderRadius: '24px',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.05)',
    maxWidth: '500px',
    width: '100%',
  },
  errorCode: {
    fontSize: '120px',
    fontWeight: '800',
    margin: '0',
    color: '#059669',
    background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    lineHeight: '1',
  },
  heading: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1e293b',
    marginTop: '20px',
    marginBottom: '10px',
  },
  text: {
    fontSize: '16px',
    color: '#64748b',
    lineHeight: '1.6',
    marginBottom: '40px',
  },
  button: {
    display: 'inline-block',
    padding: '14px 32px',
    backgroundColor: '#059669',
    color: '#ffffff',
    textDecoration: 'none',
    fontWeight: '600',
    fontSize: '16px',
    borderRadius: '50px',
    transition: 'all 0.3s ease',
    boxShadow: '0 10px 20px rgba(5, 150, 105, 0.3)',
  },

};

export default NotFoundPage;
